import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { ENotificationType } from "../../Model/ENotificationType";

import { sendNotification } from "../../redux/actions/NotificationAction";

import { LicenseApi } from "../../api";
import UserCredentialUtil from "../../Utility/UserCredentialUtil";
import { licenseAction } from "../../redux/actions/LicenseAction";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { selectIsAllowToRun } from "../../redux/reducers/LicenseReducer";

interface LicenseState {
  isLoading: boolean;
  isError: boolean;
}

const useLicenseValidation = () => {
  const dispatch = useDispatch();
  const isAllowToRun = useTypedSelector((state) => selectIsAllowToRun(state));
  const [license, setLicense] = useState<LicenseState>({
    isLoading: false,
    isError: false,
  });

  const fetchLicense = async () => {
    try {
      setLicense((prev) => ({ ...prev, isLoading: true }));
      const license = await LicenseApi.getLicenseInfo();
      dispatch(licenseAction.fetchLicenseInfo(license.isAllowToRun));
      setLicense((prev) => ({ ...prev, isLoading: false }));
      if (!license.isAllowToRun) localStorage.clear();
    } catch (error) {
      dispatch(
        sendNotification(
          ENotificationType.Error,
          (error as any)?.message || "Can't connect to Suite"
        )
      );
      setLicense((prev) => ({ ...prev, isLoading: false, isError: true }));
    }
  };

  useEffect(() => {
    fetchLicense();
  }, [dispatch]);

  return {
    isLoading: license.isLoading,
    isError: license.isError,
    isLicenseValid: isAllowToRun,
  };
};

export default useLicenseValidation;
